module.exports = __webpack_public_path__ + "src/assets/img/smoke_six.7652d7fe.svg";